import { createSelector } from 'reselect'
import getPathnameRouterSelect from 'modules/router/selectors/get-pathname/index.js'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'

const isPremiumUrlRouterSelect = createSelector(
  getPathnameRouterSelect,
  (pathname) => pathname === ROUTE_PATH.PREMIUM
)

export default isPremiumUrlRouterSelect
